// Copyright (c) Ping. All rights reserved.

import type { PollComposerError, PollDurationPreset, PollState } from './types';

export const pollStrings = {
  composerTitle: 'New poll',
  composerSubmit: 'Post poll',
  composerCancel: 'Cancel',
  questionPlaceholder: 'Ask a question',
  optionPlaceholder: (n: number): string => `Option ${n}`,
  addOption: 'Add option',
  removeOption: 'Remove option',
  kindSingle: 'One vote per person',
  kindMultiple: 'Allow multiple votes',
  anonymousLabel: 'Anonymous voting',
  durationLabel: 'Closes after',
  durationPreset: (preset: PollDurationPreset): string => {
    switch (preset) {
      case '1h':
        return '1 hour';
      case '24h':
        return '24 hours';
      case '7d':
        return '7 days';
      case 'never':
        return 'Never';
    }
  },
  cardViewVotes: 'View votes',
  cardClosed: 'Final results',
  cardTied: 'Tied',
  cardOpen: 'Open',
  cardTotalVotes: (n: number): string => (n === 1 ? '1 vote' : `${n} votes`),
  resultsTitle: 'Poll results',
  resultsClose: 'Close',
  resultsNoVotersYet: 'No votes yet',
  resultsAnonymousNotice: 'This poll is anonymous — voter names are hidden.',
  composerErrorPrefix: 'Cannot post poll',
  composerError: (e: PollComposerError): string => {
    switch (e) {
      case 'questionEmpty':
        return 'Add a question first.';
      case 'tooFewOptions':
        return 'Add at least 2 options.';
      case 'tooManyOptions':
        return 'You can have at most 10 options.';
      case 'duplicateOption':
        return 'Two options have the same text.';
      case 'optionEmpty':
        return 'Every option needs text.';
    }
  },
  cardStateBadge: (state: PollState): string => {
    switch (state) {
      case 'open':
        return 'Open';
      case 'closed':
        return 'Closed';
      case 'tied':
        return 'Tied';
    }
  },
} as const;

export type PollStrings = typeof pollStrings;
